export default function IFTrackerAccountDeletion() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8">
      <h1 className="text-4xl font-bold mb-6">Account Deletion – IFTracker</h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6">
        At <strong>IFTracker</strong>, we believe you should have full control
        over your data. You can request permanent deletion of your account and
        all associated data at any time by contacting us directly.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        📧 How to Request Deletion
      </h2>
      <p className="text-[#3D4B59] leading-relaxed mb-4">
        To request deletion of your account and associated data, please email us
        at:
      </p>

      <p className="text-lg text-[#0F6BBF] font-semibold mb-4">
        📩{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="underline hover:text-[#0C599F]"
        >
          trionapps@gmail.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6">
        Please use the <strong>same email address</strong> linked to your
        IFTracker account so that we can verify your identity. Once we receive
        your request, we will delete your account and all associated data within{" "}
        <strong>7 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        📂 What Data Will Be Deleted
      </h2>
      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2">
        <li>
          Your profile information (name, email, and photo) stored in Firebase
          Authentication.
        </li>
        <li>
          Your fasting history, hydration logs, and weight records stored in
          Firebase Firestore.
        </li>
        <li>Any analytics data associated with your user account.</li>
      </ul>

      <p className="text-[#3D4B59] mt-4">
        Some anonymized data may remain for analytical or legal compliance
        purposes, but it will not be linked to your identity.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">🛡️ Need Help?</h2>
      <p className="text-[#3D4B59] leading-relaxed">
        If you have any questions about account deletion or your data, please
        reach out to us at{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C599F]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">Last updated: October 11, 2025</p>
    </div>
  );
}
